<template>
  <div
    class="filter-btn h-9 w-full text-left px-4 flex items-center justify-between"
    :class="{ 'bg-line/[0.1]': props.withBackground }"
  >
    <div class="flex items-center gap-4">
      <Checkbox
        v-if="props.withCheckbox"
        :model-value="props.modelValue"
        @update:model-value="emit('update:modelValue', $event)"
      />
      <slot />
    </div>
    <IconButton
      v-if="props.withButton"
      class="mr-2"
      :icon-name="IconName.CHEVRON_RIGHT"
      label="Choose filter"
      :size="ButtonSize.XS"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      @click="$emit('chooseFilter')"
    />
  </div>
</template>

<script setup lang="ts">
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconName,
} from '@exfluential/ui';
import { Checkbox } from '~/components/inputs/checkbox';

type Props = {
  modelValue?: boolean;
  withBackground?: boolean;
  withButton?: boolean;
  withCheckbox?: boolean;
};
const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue', 'chooseFilter']);
</script>
